import { useTranslation } from 'react-i18next';
import { Title, PurchaseDescription } from './KYCPage/shared';

const PurchaseVehicle = () => {
    const { t } = useTranslation('giftVoucherJourney');

    return (
        <>
            <Title>{t('giftVoucherJourney:purchase.title')}</Title>
            <PurchaseDescription>{t('giftVoucherJourney:purchase.description')}</PurchaseDescription>
        </>
    );
};

export default PurchaseVehicle;
